import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/forbidden')({
  component: AdminForbiddenPage,
});

function AdminForbiddenPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="bg-white border border-rose-200 rounded-xl p-6">
        <p className="text-xs uppercase tracking-wide text-rose-600 font-semibold">403 Forbidden</p>
        <h1 className="mt-2 text-2xl font-semibold text-ink">You are not allowed to access MiseBook Admin.</h1>
        <p className="mt-3 text-stone">
          Your account is signed in, but it is not in the configured admin allowlist.
        </p>
        <div className="mt-6">
          <Link to="/app" className="btn btn-primary">
            Back to App
          </Link>
        </div>
      </div>
    </div>
  );
}
